import React from "react";
import WaitSpinner from "../components/WaitSpinner";
import AuthService from "../services/authServise";
import "./Logout.css";

function Logout() {
  let authServise = new AuthService();

  const logoutUser = async (ms) => {
    authServise.logout();
  };
  
  logoutUser(3000);

  return (
    <WaitSpinner />
  );
}

export default Logout;
